export const galleryItems = [
  {
    image: "https://cdn.magicpatterns.com/uploads/v7YN9buycCqa8wCMHaAZm7/Estuche_Floral_Quilteado_en_Rosa_Pastel.webp",
    title: "Estuches y neceseres",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/bj2z3AXhhkGmUkYUHqDeDc/Mochila_Minimalista_de_Lino_Beige.webp",
    title: "Mochilas prácticas",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/7VxBiHgiqWoroxzaBtBwm6/Bolso_azul_de_gamuza_sobre_fondo_rosa.webp",
    title: "Carteras y bolsos",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/3LDRFGEcjcLLvCUA1gjDYG/Bolso_geometrico_con_botella_de_acero.webp",
    title: "Tote bags funcionales",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/h4eq8JyjrHg3SEnZEmjHhE/Billetera_de_cuero_sobre_fondo_rosa.webp",
    title: "Billeteras y accesorios",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/sTCcXzu5jsa1q6sg6PPgxh/Bolso_tote_de_lona_en_colores_vibrantes.webp",
    title: "Bolsos para todos los días",
  },
] as const;
